/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */


import { LitigationUnion } from "../../../../types/LitigationUnion";

const getExtrajudicialRecommendationOptions = (product: LitigationUnion) => {
  if (product.productClassName === "trafficAccident") {
    return [
      { value: "agreementDone" },
      { value: "quoteNoLawsuitRecommendation" },
      { value: "quoteLawsuitRecommendation" },
      { value: "lawsuit" },
      { value: "individualText" },
    ];
  }

  if (product.productClassName === "civilServiceLaw") {
    return [
      { value: "agreementDone" },
      { value: "insufficientEvidence" },
      { value: "insufficientChancesOfSuccess" },
      { value: "costBenefitConsiderations" },
      { value: "anonymousOpponent" },
      { value: "opponentUnableToPay" },
      { value: "lawsuit" },
      //{ value: "failureToAct" }, // TODO: will be used later when failure to act is part of the automatic process
      { value: "individualText" },
    ];
  }

  return product.caseCategory === "enforceClaim"
    ? [
        { value: "agreementDone" },
        { value: "insufficientEvidence" },
        { value: "insufficientChancesOfSuccess" },
        { value: "costBenefitConsiderations" },
        { value: "anonymousOpponent" },
        { value: "opponentUnableToPay" },
        { value: "lawsuit" },
        { value: "individualText" },
      ]
    : [
        { value: "agreementDone" },
        { value: "insufficientEvidence" },
        { value: "insufficientChancesOfSuccess" },
        { value: "costBenefitConsiderations" },
        { value: "lawsuit" },
        { value: "individualText" },
      ];
};

export default getExtrajudicialRecommendationOptions;
